import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../App";
import { toast } from "sonner";
import { Loader2, AlertCircle } from "lucide-react";

const Verify = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get("token");
      
      if (!token) {
        setStatus("error");
        return;
      }

      try {
        const response = await axios.post(`${API}/auth/verify-token?token=${token}`);
        
        if (response.data.status === "success") {
          login(response.data.token);
          setStatus("success");
          toast.success("Bienvenue dans ton cocon !");
          
          // Redirect after a moment
          setTimeout(() => {
            navigate("/sanctuary");
          }, 1500);
        }
      } catch (error) {
        setStatus("error");
        toast.error("Lien invalide ou expiré");
      }
    };

    verifyToken();
  }, [searchParams, login, navigate]);

  return (
    <div className="min-h-screen bg-[#F9F7F2] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center animate-fade-in-up">
        {status === "verifying" && (
          <>
            <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-[#C5A059]/10 flex items-center justify-center animate-breathing">
              <Loader2 className="w-10 h-10 text-[#C5A059] animate-spin" strokeWidth={1.5} />
            </div>
            <h1 className="font-serif text-3xl text-[#3F2A24] mb-4">
              Vérification en cours...
            </h1>
            <p className="text-[#4B3329]">
              Un instant, nous préparons ton espace.
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-[#C5A059]/10 flex items-center justify-center">
              <svg className="w-10 h-10 text-[#C5A059]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </div>
            <h1 className="font-serif text-3xl text-[#3F2A24] mb-4">
              Bienvenue
            </h1>
            <p className="text-[#4B3329]">
              Tu es maintenant connectée.<br />
              Redirection vers ton sanctuaire...
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-[#D48C8C]/10 flex items-center justify-center">
              <AlertCircle className="w-10 h-10 text-[#D48C8C]" strokeWidth={1.5} />
            </div>
            <h1 className="font-serif text-3xl text-[#3F2A24] mb-4">
              Lien invalide
            </h1>
            <p className="text-[#4B3329] mb-8">
              Ce lien n'est plus valide ou a expiré.<br />
              Demande un nouveau lien d'accès.
            </p>
            <button
              onClick={() => navigate("/")}
              className="btn-sacred"
              data-testid="back-to-home-btn"
            >
              Retourner à l'accueil
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Verify;
